module.exports = __webpack_public_path__ + "static/workplace-giving--lg-23e1762fc28f4a70d82344fced8830d0.jpg";